/**
 * @file languages.ts
 * @description
 * -----------------------------------------------------
 * Archivo que contiene los distintos lenguajes
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-03-26
 * @author Correcta
 * @author Daniel Sentamans
 * @copyright © Correcta
 * @license Private
 * */

/**
 * supported languages for the application
 */
export const LANGUAGES = [
  { value: "es", label: "es" },
  { value: "en", label: "en" },
  { value: "fr", label: "fr" },
  { value: "de", label: "de" },
  { value: "pt", label: "pt" },
];

export const CompaniesLanguages = [
  { value: "", label: "select" },
  { value: "es", label: "es" },
  { value: "en", label: "en" },
  { value: "fr", label: "fr" },
  { value: "de", label: "de" },
  { value: "pt", label: "pt" },
];

export const LanguagesCodeWithName = [
  { value: "es", label: "Español" },
  { value: "en", label: "English" },
  { value: "pt", label: "Português" },
  { value: "de", label: "Deutsch" },
  { value: "fr", label: "Français" },
];

/**
 * supported locales for the application
 * @constant
 */
export const SUPPORTED_LOCALES = ["es", "en", "fr", "de", "pt"];
